"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
require("@hotmart/cosmos/dist/input-group/input-group.css");
const InputGroup = ({ className, ...rest }) => {
    return (0, jsx_runtime_1.jsx)("hot-input-group", { class: className, ...rest });
};
exports.default = InputGroup;
